export const getLocalStorageItem = (key: string) => {
  const value =
    typeof window !== "undefined" && localStorage && localStorage.getItem(key);
  if (!value) {
    return null;
  }
  return JSON.parse(value);
};
